"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledViewMoreButton = exports.StyledViewModalBody = exports.StyledTextChip = exports.StyledMultiSelectDropdownContainer = exports.StyledInputChipsContainer = exports.StyledInput = exports.StyledDropdownContainer = exports.StyledCustomDropdownRowDiv = exports.StyledClearChipsIconWrapper = exports.StyledChipsRenderContainer = exports.StyledChipsLabelWrapper = exports.StyledChipsContainer = exports.StyledChip = void 0;

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _shared = require("../../shared");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

const StyledChip = _styledComponents.default.div.withConfig({
  displayName: "styles__StyledChip",
  componentId: "sc-1a7spr2-0"
})([".chip-value{", ";padding-right:10px;}svg{cursor:pointer;}"], _shared.theme.typography.h6.css);

exports.StyledChip = StyledChip;
const floatingAnimation = (0, _styledComponents.keyframes)(["0%{margin-bottom:0;}50%{margin-bottom:12px;}100%{margin-bottom:16px;}"]);

const labelAnimation = () => (0, _styledComponents.css)(["", " 5s infinite alternate;"], floatingAnimation);

const StyledInputChipsContainer = _styledComponents.default.div.withConfig({
  displayName: "styles__StyledInputChipsContainer",
  componentId: "sc-1a7spr2-1"
})([".chips-values-container{display:flex;align-items:baseline;}:hover{.chips-clear-button{opacity:1;}}.react-autosuggest__input{width:100%;display:flex;border-right-width:0;border-left-width:0;border-top-width:0;border-bottom-width:1px;", ";}input:focus{outline-offset:0;outline:none;}.chips-label{color:", ";", ";margin-bottom:", ";", "}border-bottom-width:1px;border-bottom-color:", ";border-bottom-style:solid;cursor:text;.input-chip{margin-bottom:15px;}"], _shared.theme.typography.h5.css, ({
  chipsIn
}) => chipsIn ? _shared.theme.palette.brand.primary.gray : _shared.theme.palette.brand.primary.charcoal, _shared.theme.typography.h6.css, ({
  chipsIn
}) => chipsIn ? '16px' : '0', ({
  chipsIn
}) => chipsIn && `animation: ${labelAnimation};
		`, _shared.theme.palette.brand.primary.charcoal);

exports.StyledInputChipsContainer = StyledInputChipsContainer;

const StyledChipsContainer = _styledComponents.default.div.withConfig({
  displayName: "styles__StyledChipsContainer",
  componentId: "sc-1a7spr2-2"
})([".react-autosuggest__input{width:100%;display:flex;border-right-width:0;border-left-width:0;border-top-width:0;border-bottom-width:1px;", ";}input:focus{outline-offset:0;outline:none;}.chips-label{color:", ";}"], _shared.theme.typography.h5.css, ({
  chipsIn
}) => chipsIn ? _shared.theme.palette.brand.primary.gray : _shared.theme.palette.brand.primary.charcoal);

exports.StyledChipsContainer = StyledChipsContainer;

const StyledInput = _styledComponents.default.input.withConfig({
  displayName: "styles__StyledInput",
  componentId: "sc-1a7spr2-3"
})(["border-width:0;padding-bottom:15px;line-height:", ";"], ({
  chipsIn
}) => chipsIn ? '32px' : '0');

exports.StyledInput = StyledInput;

const StyledMultiSelectDropdownContainer = _styledComponents.default.div.withConfig({
  displayName: "styles__StyledMultiSelectDropdownContainer",
  componentId: "sc-1a7spr2-4"
})(["width:", ";display:flex;flex-direction:column;border-right-width:0;border-left-width:0;border-top-width:0;border-bottom-width:1px;border-bottom-color:", ";border-bottom-style:solid;", ";", ";padding-bottom:", ";position:relative;.chips-label{color:", ";}.chips_container{display:flex;flex-wrap:wrap;.chips-margin-bottom{margin-bottom:8px;}}.dropDown-trigger_icon{position:absolute;top:", ";right:8px;}.floating-dropdown-container{margin-bottom:", ";}:hover{.chips-clear-button{opacity:1;}"], ({
  width
}) => width, ({
  disabled
}) => disabled ? `${_shared.theme.palette.ui.neutral.grey7};` : `${_shared.theme.palette.brand.primary.charcoal};`, ({
  disabled
}) => disabled && `pointer-events: none;`, _shared.theme.typography.h6.css, ({
  chipsIn
}) => chipsIn ? '7px' : '', ({
  chipsIn
}) => chipsIn ? _shared.theme.palette.brand.primary.gray : _shared.theme.palette.brand.primary.charcoal, ({
  chipsIn
}) => chipsIn ? '50%' : '0', ({
  chipsIn,
  labelMargin
}) => !chipsIn ? '16px' : labelMargin);

exports.StyledMultiSelectDropdownContainer = StyledMultiSelectDropdownContainer;

const StyledChipsRenderContainer = _styledComponents.default.div.withConfig({
  displayName: "styles__StyledChipsRenderContainer",
  componentId: "sc-1a7spr2-5"
})(["display:flex;flex-wrap:", ";.chips-margin-bottom{margin-bottom:8px;}overflow-x:", ";align-items:baseline;"], ({
  chipsAlign
}) => chipsAlign === 'vertical' ? 'wrap' : 'nowrap', ({
  chipsAlign
}) => chipsAlign === 'horizontal' ? 'scroll' : 'none');

exports.StyledChipsRenderContainer = StyledChipsRenderContainer;

const StyledDropdownContainer = _styledComponents.default.div.withConfig({
  displayName: "styles__StyledDropdownContainer",
  componentId: "sc-1a7spr2-6"
})(["position:absolute;top:calc(100% + 4px);z-index:", ";display:flex;flex-direction:column;width:", ";max-height:219px;background:", ";border:1px solid ", ";", ";border-radius:4px;padding:", ";overflow-y:scroll;::-webkit-scrollbar{-webkit-appearance:none;width:4px;}::-webkit-scrollbar-thumb{border-radius:10px;background-color:", ";box-shadow:0 0 0.0625rem rgba(255,255,255,0.5);}.checkbox_background_hover{&:hover{background:", " !important;}}"], _shared.theme.zIndex.drawer, ({
  dropdownWidth
}) => dropdownWidth, _shared.theme.palette.brand.primary.white, _shared.theme.palette.ui.neutral.grey2, _shared.theme.shadows.light.level2, ({
  dropdownPadding
}) => dropdownPadding, _shared.theme.palette.brand.primary.gray, _shared.theme.palette.brand.primary.white);

exports.StyledDropdownContainer = StyledDropdownContainer;

const StyledTextChip = _styledComponents.default.div.withConfig({
  displayName: "styles__StyledTextChip",
  componentId: "sc-1a7spr2-7"
})(["", ";padding-right:5px;padding-bottom:9px;color:", ";"], _shared.theme.typography.h6.css, _shared.theme.palette.brand.primary.charcoal);

exports.StyledTextChip = StyledTextChip;

const StyledChipsLabelWrapper = _styledComponents.default.div.withConfig({
  displayName: "styles__StyledChipsLabelWrapper",
  componentId: "sc-1a7spr2-8"
})(["display:flex;justify-content:space-between;.chips-label{", ";}"], ({
  disabled
}) => disabled && `color: ${_shared.theme.palette.ui.neutral.grey7}`);

exports.StyledChipsLabelWrapper = StyledChipsLabelWrapper;

const StyledClearChipsIconWrapper = _styledComponents.default.div.withConfig({
  displayName: "styles__StyledClearChipsIconWrapper",
  componentId: "sc-1a7spr2-9"
})(["position:relative;top:4px;right:4px;float:right;opacity:0;"]);

exports.StyledClearChipsIconWrapper = StyledClearChipsIconWrapper;

const StyledViewMoreButton = _styledComponents.default.div.withConfig({
  displayName: "styles__StyledViewMoreButton",
  componentId: "sc-1a7spr2-10"
})(["", ";color:", ";cursor:pointer;"], _shared.theme.typography.h6.css, _shared.theme.palette.ui.cta.blue);

exports.StyledViewMoreButton = StyledViewMoreButton;

const StyledCustomDropdownRowDiv = _styledComponents.default.div.withConfig({
  displayName: "styles__StyledCustomDropdownRowDiv",
  componentId: "sc-1a7spr2-11"
})([".text-label{padding:9px 0px 9px 16px;", ";}"], _shared.theme.typography.h6.css);

exports.StyledCustomDropdownRowDiv = StyledCustomDropdownRowDiv;

const StyledViewModalBody = _styledComponents.default.div.withConfig({
  displayName: "styles__StyledViewModalBody",
  componentId: "sc-1a7spr2-12"
})(["display:flex;flex-direction:row;flex-wrap:wrap;overflow-y:scroll;align-items:baseline;align-content:flex-start;height:300px;-ms-overflow-style:none;scrollbar-width:none;::-webkit-scrollbar{display:none;}> button{margin-bottom:5px;}"]);

exports.StyledViewModalBody = StyledViewModalBody;